/**
 * Custom hook to manage the selection state of controls and sections.
 * This isolates all selection-related logic, such as selecting a single item
 * and ensuring only one item (or none) is selected at a time.
 */

import { useState } from 'react';

export const useSelectionManager = () => {
    const [selectedControlId, setSelectedControlId] = useState(null);
    const [selectedSectionId, setSelectedSectionId] = useState(null);

    //Sets the selected control ID and clears any selected section.
    const handleSelectControl = (controlId) => {
        setSelectedControlId(controlId);
        setSelectedSectionId(null);
    };

    // Sets the selected section ID and clears any selected control.
    const handleSelectSection = (sectionId) => {
        setSelectedSectionId(sectionId);
        setSelectedControlId(null);
    };

    //Clears all selections.
    const handleDeselectAll = () => {
        setSelectedControlId(null);
        setSelectedSectionId(null);
    };

    return {
        selectedControlId,
        selectedSectionId,
        selectControl: handleSelectControl,
        selectSection: handleSelectSection,
        deselectAll: handleDeselectAll,
    };
};